import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6874687a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full h-full flex flex-nowrap bg-System/app_grey_95" }
const _hoisted_2 = { class: "h-full relative w-[72px] bg-System/app_grey_22" }
const _hoisted_3 = { class: "absolute w-full h-[72px] top-0 bg-Text/text_high" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex w-[72px]" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "circle" }),
  /*#__PURE__*/_createElementVNode("div", { class: "circle" }),
  /*#__PURE__*/_createElementVNode("div", { class: "circle" }),
  /*#__PURE__*/_createElementVNode("div", { class: "circle" }),
  /*#__PURE__*/_createElementVNode("div", { class: "circle" }),
  /*#__PURE__*/_createElementVNode("div", { class: "circle" })
], -1))
const _hoisted_6 = { class: "m-[24px] w-full bg-System/app_white rounded-sm flex border-[1px] border-System/app_border border-solid" }
const _hoisted_7 = { class: "flex items-center w-full flex-col justify-center" }
const _hoisted_8 = { class: "w-[250px]" }
const _hoisted_9 = ["data"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-[40px] font-gordita-medium flex text-Text/text_high text-[20px]" }, "Authenticating User", -1))

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { inject, onMounted } from 'vue';
import apolloClient from '@/plugins/GraphQL/Apollo/client';
import {
  Authentication_Login_AzureadDocument,
  Authentication_Login_AzureadMutation,
  Authentication_Login_AzureadMutationVariables,
  Authentication_Save_Azuread_CodeDocument,
  Authentication_Save_Azuread_CodeMutation,
  Authentication_Save_Azuread_CodeMutationVariables,
} from '@/graphql/codegen/generated/graphql';
import { useRouter } from 'vue-router';
import { Routes } from '@/router/router.const';
import { IKPlatformAuthentication } from '@/modules/platformAuthentication/platformAuthentication.injectionKeys';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import loadingLogo from '@/assets/images/login/incredibuild_logo_start.svg';
import ibLogo from '@/assets/images/login/logo-small.svg';
import { useAzure } from '@/views/login/loginComponents/azure/azure.helpers';
import { ErrorCodes } from '@/const/errorCodes';
import { envConfig } from '@/services/features';


export default /*#__PURE__*/_defineComponent({
  __name: 'azureCallback',
  setup(__props) {

const router = useRouter();
const platformAuthentication = inject(IKPlatformAuthentication);
const coordinatorsService = inject(IKCoordinatorsService);
const { getQueryParamsCode, getRedirectUri } = useAzure();

const handleAzureLogin = async (code: string) => {
  if (!code) {
    await router.push(Routes.Login);
  }
  const redirectUri = getRedirectUri();
  const lastRoute = sessionStorage.getItem('lastRoute') || envConfig.defaultRoute;
  if (platformAuthentication?.getAccessToken()) {
    // we are already logged in with local user and we are trying to login to azure in order to get security groups
    const result = await apolloClient.mutate<Authentication_Save_Azuread_CodeMutation, Authentication_Save_Azuread_CodeMutationVariables>({
      mutation: Authentication_Save_Azuread_CodeDocument,
      variables: {
        data: {
          code,
          redirectUri,
        },
      },
    });
    if (result?.data?.authentication_save_azuread_code) {
      sessionStorage.setItem('authMode', String(true));
      await router.push({ name: lastRoute });
    } else {
      await router.push({ name: 'login' });
    }
  } else {
    try {
      const result = await apolloClient.mutate<Authentication_Login_AzureadMutation, Authentication_Login_AzureadMutationVariables>({
        mutation: Authentication_Login_AzureadDocument,
        variables: {
          data: {
            code,
            redirectUri,
          },
        },
      });
      const accessToken = result?.data?.authentication_login_azuread?.accessToken;
      const refreshToken = result?.data?.authentication_login_azuread?.refreshToken;
      if (accessToken && refreshToken) {
        platformAuthentication?.loginAzure({ accessToken, refreshToken });
        if (platformAuthentication?.getAccessToken()) {
          await apolloClient.cache.reset();
          coordinatorsService?.reset();
          await router.push({ name: lastRoute });
        } else {
          await router.push({ name: 'login' });
        }
      }
    } catch (error) {
      const errorCode = (error as any).graphQLErrors[0].extensions.applicationErrorCode;
      if (platformAuthentication) {
        platformAuthentication.azureErrorCode.value = errorCode;
      }
      if (errorCode === ErrorCodes.INVALID_USER_NAME_OR_PASSWORD || errorCode === ErrorCodes.INVALID_AUTHENTICATION_GROUP_MAPPING) {
        await router.push({ name: 'login' });
      }
    }
  }
};

onMounted(async () => {
  const code = getQueryParamsCode();
  if (code) {
    await handleAzureLogin(code);
  } else await router.push({ name: 'login' });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, {
    style: {"width":"100%"},
    class: "bg-System/app_grey_22"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _unref(ibLogo),
              class: "mt-[16px] ml-[16px] w-[40px]"
            }, null, 8, _hoisted_4)
          ]),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("object", {
                type: "image/svg+xml",
                data: _unref(loadingLogo)
              }, null, 8, _hoisted_9)
            ]),
            _hoisted_10
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})